"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6214],{

/***/ 95953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42844);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26032);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _clients_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67303);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);



var _excluded = ["value", "onChange", "onBlur", "maxValues"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var IndustriesSelect = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function IndustriesSelect(_ref, ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      _ref$maxValues = _ref.maxValues,
      maxValues = _ref$maxValues === void 0 ? -1 : _ref$maxValues,
      textFieldProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      options = _useState[0],
      setOptions = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);
                _context.next = 3;
                return (0,_clients_api__WEBPACK_IMPORTED_MODULE_3__/* .getIndustries */ .$G)();

              case 3:
                res = _context.sent;
                setOptions(res.sort(function (a, b) {
                  return a.category.index === b.category.index ? a.index - b.index : a.category.index - b.category.index;
                }));
                setIsLoading(false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetch();
  }, []);

  if (isLoading) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    value: value || [],
    multiple: true,
    openOnFocus: true,
    groupBy: function groupBy(id) {
      var _options$find;

      return (_options$find = options.find(function (o) {
        return o.id === id;
      })) === null || _options$find === void 0 ? void 0 : _options$find.category.name;
    },
    id: "select-industries",
    options: options.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }),
    getOptionLabel: function getOptionLabel(id) {
      var _options$find2;

      return (_options$find2 = options.find(function (o) {
        return o.id === id;
      })) === null || _options$find2 === void 0 ? void 0 : _options$find2.name;
    },
    filterSelectedOptions: true,
    limitTags: maxValues,
    onChange: function onChange(e, values) {
      if (maxValues !== -1 && values.length > maxValues) {
        e.preventDefault();
        return;
      }

      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      _onChange.apply(void 0, [e, values].concat(rest));
    },
    onBlur: onBlur,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread({
        ref: ref
      }, textFieldProps), params), {}, {
        variant: "outlined",
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          inputMode: 'none'
        })
      }));
    }
  });
});
/* harmony default export */ __webpack_exports__["Z"] = (IndustriesSelect);

/***/ }),

/***/ 70483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52186);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58883);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26032);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9041);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80562);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SecretInput = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _ref);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showPassword = _useState[0],
      setShowPassword = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
    type: showPassword ? 'text' : 'password',
    InputProps: {
      endAdornment: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        position: "end",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          "aria-label": showPassword ? 'パスワードを隠す' : 'パスワードを表示する',
          onClick: function onClick() {
            return setShowPassword(!showPassword);
          },
          onMouseDown: function onMouseDown() {
            return setShowPassword(!showPassword);
          },
          children: showPassword ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        })
      })
    },
    ref: ref
  }));
});
SecretInput.displayName = 'SecretInput';
/* harmony default export */ __webpack_exports__["Z"] = (SecretInput);

/***/ }),

/***/ 61980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(71383);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17674);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4730);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16829);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26032);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(31538);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31362);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68346);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(75084);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clients_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67303);
/* harmony import */ var _config_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52249);
/* harmony import */ var _helpers_formValidations__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(92736);
/* harmony import */ var _SecretInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70483);
/* harmony import */ var _IndustriesSelect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95953);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);






var _templateObject;

var _excluded = ["agreement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











 // import GoogleLoginForm from './GoogleLoginForm';





var SignupForm = function SignupForm(_ref) {
  var size = _ref.size,
      submitText = _ref.submitText,
      onComplete = _ref.onComplete;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var query = {
    path: router.asPath
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      businessScales = _useState[0],
      setBusinessScales = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = setBusinessScales;
                _context.next = 3;
                return (0,_clients_api__WEBPACK_IMPORTED_MODULE_6__/* .getBusinessScales */ .P$)();

              case 3:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetch();
  }, []);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      success = _useState3[0],
      setSuccess = _useState3[1];

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
    mode: 'onChange',
    defaultValues: {
      agreement: false,
      email: '',
      password: '',
      name: '',
      companyName: '',
      departmentName: '',
      personalPhone: '',
      storeName: '',
      industryIds: [],
      businessScaleId: ''
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      errors = _useForm.formState.errors,
      setValue = _useForm.setValue;

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(_ref3) {
      var agreement, data, res;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              agreement = _ref3.agreement, data = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref3, _excluded);

              if (agreement) {
                _context2.next = 4;
                break;
              }

              setErrorMessage('利用規約・プライバシーポリシーへの同意をお願いします');
              return _context2.abrupt("return");

            case 4:
              setErrorMessage('');
              _context2.next = 7;
              return (0,_clients_api__WEBPACK_IMPORTED_MODULE_6__/* .signup */ .IU)(_objectSpread(_objectSpread({}, data), {}, {
                firstTouchURL: (0,_config_cookie__WEBPACK_IMPORTED_MODULE_7__/* .getFirstTouchURL */ .q_)(),
                lastTouchURL: (0,_config_cookie__WEBPACK_IMPORTED_MODULE_7__/* .getLastTouchURL */ .Fq)()
              }));

            case 7:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 14;
                break;
              }

              _context2.next = 11;
              return onComplete === null || onComplete === void 0 ? void 0 : onComplete();

            case 11:
              setSuccess(true);
              _context2.next = 15;
              break;

            case 14:
              setErrorMessage(res.error || '会員登録に失敗しました。');

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  if (success) {
    router.push('/account/signup/?pages=2');
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("form", {
      onSubmit: handleSubmit(onSubmit),
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        spacing: 2,
        children: [[['name', '姓名'], ['companyName', '会社名・屋号'], ['departmentName', '部署']].map(function (_ref5) {
          var _ref6 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_ref5, 2),
              name = _ref6[0],
              label = _ref6[1];

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
            control: control,
            name: name,
            rules: {
              required: true
            },
            render: function render(_ref7) {
              var field = _ref7.field,
                  fieldState = _ref7.fieldState;
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, _objectSpread({
                variant: "outlined",
                type: "text",
                id: "input-".concat(name.replace('Name', '-name')),
                fullWidth: true,
                required: true,
                error: !!fieldState.error,
                helperText: fieldState.error && "".concat(label, "\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"),
                label: label
              }, field));
            }
          }, name);
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "personalPhone",
          rules: {
            required: true,
            validate: function validate(value) {
              return (0,_helpers_formValidations__WEBPACK_IMPORTED_MODULE_17__/* .isValidPhoneNumber */ .y)(value);
            }
          },
          render: function render(_ref8) {
            var field = _ref8.field,
                fieldState = _ref8.fieldState;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, _objectSpread({
              variant: "outlined",
              type: "text",
              id: "input-personal-phone",
              fullWidth: true,
              required: true,
              error: !!fieldState.error,
              helperText: fieldState.error ? fieldState.error.message || '電話番号を入力してください' : null,
              label: "\u96FB\u8A71\u756A\u53F7",
              inputProps: {
                inputMode: 'tel'
              },
              InputProps: {
                type: 'tel'
              }
            }, field));
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "industryIds",
          rules: {
            required: true
          },
          render: function render(_ref9) {
            var field = _ref9.field,
                fieldState = _ref9.fieldState;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_IndustriesSelect__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, field), {}, {
              fullWidth: true,
              error: !!fieldState.error,
              helperText: fieldState.error ? fieldState.error.message || 'お店の業種を選択してください' : '最大3つ選択可能',
              label: "\u304A\u5E97\u306E\u696D\u7A2E\u3092\u6559\u3048\u3066\u4E0B\u3055\u3044",
              maxValues: 3,
              onChange: function onChange(_e, value) {
                setValue('industryIds', value);
              }
            }));
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "businessScaleId",
          rules: {
            required: true
          },
          render: function render(_ref10) {
            var field = _ref10.field,
                fieldState = _ref10.fieldState;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, field), {}, {
              select: true,
              label: "\u904B\u55B6\u5E97\u8217\u6570\u3092\u6559\u3048\u3066\u4E0B\u3055\u3044",
              id: "select-business-scale",
              SelectProps: {
                displayEmpty: true,
                renderValue: function renderValue(selected) {
                  var found = businessScales.find(function (_ref11) {
                    var id = _ref11.id;
                    return id === selected;
                  });

                  if (found) {
                    return found.name;
                  }

                  return '';
                }
              },
              error: !!fieldState.error,
              helperText: fieldState.error ? fieldState.error.message || '運営店舗数を選択してください' : null,
              required: true,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                value: "",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("em", {
                  children: "\u904B\u55B6\u5E97\u8217\u6570\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
                })
              }), businessScales.map(function (_ref12) {
                var id = _ref12.id,
                    name = _ref12.name;
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                  value: id,
                  children: name
                }, id);
              })]
            }));
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "email",
          rules: {
            required: true
          },
          render: function render(_ref13) {
            var field = _ref13.field;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, _objectSpread({
              variant: "outlined",
              type: "email",
              fullWidth: true,
              required: true,
              error: !!errors.email,
              helperText: errors.email && 'メールアドレスを入力してください',
              label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
              size: size || 'medium'
            }, field));
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "password",
          rules: {
            required: true,
            minLength: 8
          },
          render: function render(_ref14) {
            var field = _ref14.field;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_SecretInput__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread({
              variant: "outlined",
              fullWidth: true,
              required: true,
              error: !!errors.password,
              helperText: errors.password && '最低 8 文字のパスワードを入力してください',
              label: "\u30D1\u30B9\u30EF\u30FC\u30C9",
              size: size || 'medium'
            }, field));
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
          control: control,
          name: "agreement",
          render: function render(_ref15) {
            var field = _ref15.field;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
              control: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, _objectSpread({}, field)),
              label: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                style: {
                  fontSize: '0.8em',
                  color: '#666'
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                  href: "/terms",
                  target: "_blank",
                  color: "#666",
                  children: "\u5229\u7528\u898F\u7D04"
                }), "\u30FB", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                  href: "https://kutikomi.com/privacy_policy/",
                  target: "_blank",
                  color: "#666",
                  children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
                }), "\u306B\u540C\u610F"]
              })
            });
          }
        }), errorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
          variant: "body2",
          sx: {
            color: 'error.main'
          },
          children: errorMessage
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
          type: "submit",
          variant: "contained",
          color: "primary",
          size: size ? size : 'large',
          sx: {
            padding: '15px',
            fontWeight: 700
          },
          children: submitText !== null && submitText !== void 0 ? submitText : '無料で会員登録'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: {
            pathname: '/login',
            query: query
          },
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
            variant: "body2",
            color: "textSecondary",
            sx: {
              textAlign: 'center'
            },
            children: "\u30ED\u30B0\u30A4\u30F3\u306F\u3053\u3061\u3089"
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SignupForm);
var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(["\n  border-radius: 4px;\n  display: flex;\n  background: #fff;\n  color: #000;\n  padding: 24px;\n  width: 100%;\n"])));

/***/ }),

/***/ 58206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75084);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29630);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _forms_SignupForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61980);
/* harmony import */ var src_clients_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67303);
/* harmony import */ var src_helpers_userRegistrationHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83972);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var MemberRegistrationPrompt = function MemberRegistrationPrompt(_ref) {
  var user = _ref.user;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var onSkipSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,src_clients_api__WEBPACK_IMPORTED_MODULE_4__/* .skipRegisterSteps */ .XK)();

            case 2:
              router.reload();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSkipSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!user) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
          padding: '0 24px',
          fontSize: '0.85em',
          color: 'text.secondary'
        },
        children: ["\u53E3\u30B3\u30DF\u30A2\u30AB\u30C7\u30DF\u30FC\u306F\u5E97\u8217\u3092\u304A\u6301\u3061\u306E\u5E97\u9577\u69D8\u3001\u30B9\u30BF\u30C3\u30D5\u306E\u65B9\u3005\u306B\u5411\u3051\u305F\u30B5\u30FC\u30D3\u30B9\u3067\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("br", {}), "\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u95B2\u89A7\u306B\u306F\u4F1A\u54E1\u767B\u9332\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_forms_SignupForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})]
    });
  }

  if ((0,src_helpers_userRegistrationHelpers__WEBPACK_IMPORTED_MODULE_5__/* .isOnlyStep1Completed */ .lI)(user)) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      sx: {
        p: 2
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        spacing: 2,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "/account/signup/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            variant: "contained",
            size: "large",
            fullWidth: true,
            component: "a",
            children: "\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u56DE\u7B54\u3059\u308B"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          variant: "contained",
          size: "large",
          fullWidth: true,
          component: "a",
          onClick: onSkipSubmit,
          children: "\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4ECA\u3059\u3050\u307F\u308B"
        })]
      })
    });
  }

  if (!user.filledAll) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      sx: {
        p: 2
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "h6",
        align: "center",
        color: "text.primary",
        gutterBottom: true,
        sx: {
          mb: 2
        },
        children: "\u4F1A\u54E1\u767B\u9332\u3092\u5B8C\u4E86\u3055\u305B\u3066\u304F\u3060\u3055\u3044"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/account/signup/",
        passHref: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          variant: "contained",
          size: "large",
          fullWidth: true,
          component: "a",
          children: "\u4F1A\u54E1\u767B\u9332\u306B\u9032\u3080"
        })
      })]
    });
  }

  return null;
};

/* harmony default export */ __webpack_exports__["Z"] = (MemberRegistrationPrompt);

/***/ }),

/***/ 87061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12971);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9942);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10160);
/* harmony import */ var _mui_icons_material_KeyboardArrowUpSharp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30148);
/* harmony import */ var _contexts_ScrollTopButtoPositionContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16736);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var ScrollTop = function ScrollTop() {
  var trigger = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    target:  false ? 0 : window,
    disableHysteresis: true,
    threshold: 100
  });
  var context = (0,_contexts_ScrollTopButtoPositionContext__WEBPACK_IMPORTED_MODULE_0__/* .useScrollTopButtonPositionContext */ .d)();

  var handleClick = function handleClick() {
    var anchor = document.getElementsByTagName('div')[0];

    if (anchor) {
      anchor.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    "in": trigger,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      onClick: handleClick,
      sx: {
        position: 'fixed',
        bottom: context.bottom,
        right: context.right,
        zIndex: 1000
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        size: "large",
        "aria-label": "scroll back to top",
        color: "secondary",
        sx: {
          borderRadius: 0,
          background: '#505050',
          width: {
            xs: '56px',
            md: '80px'
          },
          height: {
            xs: '56px',
            md: '80px'
          }
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_KeyboardArrowUpSharp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          fontSize: "large",
          sx: {
            width: '50%',
            height: '50%'
          }
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ScrollTop);

/***/ }),

/***/ 41141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77745);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95398);
/* harmony import */ var _graphics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18244);
/* harmony import */ var _MemberRegistrationPrompt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58206);
/* harmony import */ var src_helpers_userRegistrationHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83972);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var SignupDialog = function SignupDialog(_ref) {
  var _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      open = _ref.open,
      user = _ref.user,
      showClose = _ref.showClose,
      title = _ref.title;
  var dialogTitle = title !== null && title !== void 0 ? title : (0,src_helpers_userRegistrationHelpers__WEBPACK_IMPORTED_MODULE_2__/* .generateDialogTitle */ .Mk)(user);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    open: open,
    onClose: onClose,
    PaperProps: {
      style: {
        backgroundColor: '#fff'
      }
    },
    children: [showClose !== true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      children: dialogTitle
    }), showClose === true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: {
          display: 'flex',
          flexDirection: 'row'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          sx: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column'
          },
          children: dialogTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            size: "small",
            onClick: onClose,
            sx: {
              ml: 1
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_graphics__WEBPACK_IMPORTED_MODULE_0__/* .Close */ .x8, {})
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      sx: {
        mx: 0,
        px: 1
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_MemberRegistrationPrompt__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        user: user
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SignupDialog);

/***/ }),

/***/ 74137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16829);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29630);
/* harmony import */ var _mui_icons_material_OpenInNew__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54048);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _templateObject;








var SiteLink = function SiteLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      variant = _ref.variant;
  var isExternal = href.startsWith('http');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: href,
      passHref: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: "a",
        variant: variant || 'body1',
        className: isExternal ? 'external' : undefined,
        target: isExternal ? '_blank' : undefined,
        children: [children, isExternal ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material_OpenInNew__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          sx: {
            height: '0.5em'
          }
        }) : undefined]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SiteLink);
var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li */ .Z.li(_templateObject || (_templateObject = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  list-style: none;\n  flex: 1 0 33%;\n  padding: 0;\n  margin: 0;\n  a {\n    color: #fff;\n    text-decoration: none;\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n"])));

/***/ }),

/***/ 56214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(64489);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./src/config/assets.ts
var assets = __webpack_require__(78866);
// EXTERNAL MODULE: ./src/graphics/index.ts + 46 modules
var graphics = __webpack_require__(18244);
// EXTERNAL MODULE: ./src/components/forms/SignupForm.tsx
var SignupForm = __webpack_require__(61980);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/global/BottomEyecatch.tsx


var _templateObject, _templateObject2, _templateObject3;









var BottomEyecatch = function BottomEyecatch(_ref) {
  var isLoggedIn = _ref.isLoggedIn;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          display: 'flex',
          flexDirection: {
            md: 'row-reverse',
            xs: 'column'
          },
          padding: {
            md: '10px 0',
            xs: '48px 0'
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            flexGrow: 1,
            display: 'flex',
            alignContent: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 1,
            textAlign: {
              md: 'left',
              xs: 'center'
            },
            maxWidth: {
              md: '60%'
            },
            paddingTop: {
              md: 0,
              xs: '70px'
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "p",
            sx: {
              fontWeight: '400',
              fontSize: '18px'
            },
            children: "\u3042\u306A\u305F\u306E\u304A\u5E97\u3092\u3082\u3063\u3068\u7E41\u76DB\u5E97\u306B\uFF01"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "p",
            sx: {
              fontWeight: '700',
              fontSize: {
                md: '24px',
                xs: '20px'
              }
            },
            children: "\u4ED5\u8FBC\u307F\u306E\u5408\u9593\u306B\u901A\u3046\u304A\u5E97\u306E\u5B66\u6821"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              width: {
                xs: '236px',
                md: '377px'
              },
              margin: {
                md: '10px 0 0 0',
                xs: '10px auto 0 auto'
              }
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* LogoWhite */.y3, {})
          })]
        }), !isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            flexGrow: 1,
            padding: {
              md: '56px 64px 56px 0',
              xs: '20px 0 0 0'
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SignupForm/* default */.Z, {})
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundImage, {})]
  });
};

/* harmony default export */ var global_BottomEyecatch = (BottomEyecatch);
var Main = (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n  position: relative;\n"])));
var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: relative;\n  background: #000;\n  color: #fff;\n"])));
var BackgroundImage = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  opacity: 0.5;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url('", "eyecatches/bottom-eyecatch.jpg') no-repeat center top;\n  background-size: cover;\n  @media (max-width: 900px) {\n    background-image: url(", "eyecatches/bottom-eyecatch-portrait.jpg);\n  }\n"])), assets/* prefix */.O, assets/* prefix */.O);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./src/config/links.ts
var links = __webpack_require__(45082);
// EXTERNAL MODULE: ./src/components/global/SiteLink.tsx
var SiteLink = __webpack_require__(74137);
;// CONCATENATED MODULE: ./src/components/global/Footer.tsx



var Footer_templateObject, Footer_templateObject2;








var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Footer_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      maxWidth: "lg",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        spacing: 4,
        sx: {
          padding: '20px 0 40px 0'
        },
        justifyContent: "center",
        alignItems: "center",
        children: links/* sitePages.map */.s.map(function (_ref) {
          var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
              label = _ref2[0],
              href = _ref2[1];

          return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink/* default */.Z, {
              href: href,
              children: label
            })
          }, href);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
        light: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          container: true,
          spacing: 2,
          sx: {
            padding: '40px 0'
          },
          justifyContent: "center",
          alignItems: "center",
          children: links/* footerLinks.map */.d.map(function (_ref3) {
            var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
                label = _ref4[0],
                href = _ref4[1];

            return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink/* default */.Z, {
                href: href,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
                  children: label
                })
              })
            }, href);
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Copyright, {
      children: "Copyright \xA9 2022 mov inc."
    })]
  });
};

/* harmony default export */ var global_Footer = (Footer);
var Footer_Wrapper = emotion_styled_browser_esm/* default.footer */.Z.footer(Footer_templateObject || (Footer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #000;\n  color: #fff;\n  margin-top: 32px;\n"])));
var Copyright = emotion_styled_browser_esm/* default.p */.Z.p(Footer_templateObject2 || (Footer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 auto;\n  padding-bottom: 24px;\n  font-size: 0.8rem;\n  text-align: center;\n"])));
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(60684);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(81284);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./src/config/pageTitles.ts
var pageTitles = __webpack_require__(88499);
;// CONCATENATED MODULE: ./src/components/global/Header.tsx



var Header_templateObject, Header_templateObject2, Header_templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;













var Header = function Header(_ref) {
  var user = _ref.user,
      isLoadingUser = _ref.isLoadingUser,
      id = _ref.id;

  var _useState = (0,react.useState)(false),
      isDrawerOpen = _useState[0],
      setIsDrawerOpen = _useState[1];

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Header_Wrapper, {
    id: id,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Line1, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          height: '46px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            fontSize: '0.8em',
            flexGrow: 1
          },
          children: "\u4ED5\u8FBC\u307F\u306E\u5408\u9593\u306B\u901A\u3046\u304A\u5E97\u306E\u5B66\u6821"
        }), !isLoadingUser && pathname !== '/thanks' && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          children: user ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/account",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              color: "secondary",
              variant: "text",
              component: "a",
              children: "\u30DE\u30A4\u30DA\u30FC\u30B8"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/login",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "secondary",
                variant: "text",
                component: "a",
                children: "\u30ED\u30B0\u30A4\u30F3"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SignupButton, {
                variant: "contained",
                color: "secondary",
                component: "a",
                sx: {
                  display: {
                    md: 'inline-block',
                    xs: 'none'
                  }
                },
                children: "\u65B0\u898F\u767B\u9332"
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Line2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
          disableGutters: true,
          sx: {
            gap: 3
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              flexGrow: 1,
              height: {
                md: '77px',
                xs: '44px'
              },
              padding: {
                md: '20px 0',
                xs: '10px 0'
              }
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* Logo */.TR, {})
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              py: 2,
              flexGrow: 0,
              gap: 4,
              display: {
                md: 'flex',
                xs: 'none'
              }
            },
            children: links/* sitePages.map */.s.map(function (_ref2) {
              var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
                  label = _ref3[0],
                  href = _ref3[1],
                  icon = _ref3[2];

              return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                  p: 0,
                  m: 0,
                  borderBottom: pathname.indexOf(href.replace(/\/$/, '')) === 0 ? '2px solid #000' : undefined
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: href,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Anchor, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                      sx: {
                        fontSize: '12px',
                        letterSpacing: '1.2px',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        '&:before': {
                          content: "url(".concat(icon, ")")
                        }
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: label
                      })
                    })
                  })
                }, href)
              }, href);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            sx: {
              flexGrow: 0,
              display: {
                md: 'none',
                xs: 'flex'
              }
            },
            onClick: function onClick() {
              return setIsDrawerOpen(!isDrawerOpen);
            },
            children: isDrawerOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* Close */.x8, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* Humburger */.vS, {})
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
      anchor: "top",
      open: isDrawerOpen,
      sx: {
        zIndex: 1100
      },
      onClose: function onClose() {
        return setIsDrawerOpen(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DrawerInner, {
        children: [!user && /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
          spacing: 1,
          sx: {
            paddingBottom: '20px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/login",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              color: "secondary",
              variant: "outlined",
              size: "large",
              component: "a",
              sx: {
                border: '2px solid #FFD900',
                fontWeight: 700
              },
              children: "\u30ED\u30B0\u30A4\u30F3"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              color: "primary",
              variant: "contained",
              size: "large",
              component: "a",
              onClick: function onClick() {
                return setIsDrawerOpen(false);
              },
              sx: {
                fontWeight: 700
              },
              children: "\u7121\u6599\u3067\u4F1A\u54E1\u767B\u9332"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(List/* default */.Z, {
          component: "div",
          children: [links/* sitePages.map */.s.map(function (_ref4, i) {
            var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 3),
                label = _ref5[0],
                href = _ref5[1],
                icon = _ref5[2];

            return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: href,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                divider: i < links/* sitePages.length */.s.length - 1 || !!user,
                secondaryAction: /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* ChevronRight */._Q, {}),
                button: true,
                component: "a",
                sx: {
                  padding: '15px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                  sx: {
                    display: 'flex',
                    marginRight: '16px',
                    '&:before': {
                      content: "url(".concat(icon, ")"),
                      marginRight: '8px'
                    }
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                    children: label
                  })
                })
              })
            }, href);
          }), user && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/account",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
              secondaryAction: /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* ChevronRight */._Q, {}),
              button: true,
              component: "a",
              sx: {
                padding: '15px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                children: pageTitles/* myPage */.Bs
              })
            })
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var global_Header = (Header);
var Header_Wrapper = emotion_styled_browser_esm/* default.header */.Z.header(Header_templateObject || (Header_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1200;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  background-color: #ffffff;\n"])));
var DrawerInner = emotion_styled_browser_esm/* default.div */.Z.div(Header_templateObject2 || (Header_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 120px 10px 10px 10px;\n  background-color: #f9f9f9;\n"])));
var Line1 = emotion_styled_browser_esm/* default.div */.Z.div(Header_templateObject3 || (Header_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #ffd900;\n"])));
var Line2 = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: #ffffff;\n"])));
var LogoWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  svg {\n    height: 100%;\n  }\n"])));
var SignupButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: 700;\n  border-radius: 20px;\n  padding: 3px 20px;\n"])));
var Anchor = emotion_styled_browser_esm/* default.a */.Z.a(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  color: #000;\n  transition: opacity 0.1s ease-in-out;\n  &:hover {\n    opacity: 0.65\n  }\n"])));
// EXTERNAL MODULE: ./src/components/global/ScrollTop.tsx
var ScrollTop = __webpack_require__(87061);
// EXTERNAL MODULE: ./src/clients/api.ts
var api = __webpack_require__(67303);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/global/MemberRegistrationPrompt.tsx
var MemberRegistrationPrompt = __webpack_require__(58206);
// EXTERNAL MODULE: ./src/contexts/CurriculumContext.tsx
var CurriculumContext = __webpack_require__(56532);
// EXTERNAL MODULE: ./src/helpers/userRegistrationHelpers.ts
var userRegistrationHelpers = __webpack_require__(83972);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./src/contexts/SignupDialogContext.tsx

var _excluded = ["children"];


;
var SignupDialogContext = /*#__PURE__*/(0,react.createContext)(null);
var useSignupDialogContext = function useSignupDialogContext() {
  return (0,react.useContext)(SignupDialogContext);
};
var useSignDialogContextState = function useSignDialogContextState() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCloseShown = _useState2[0],
      setIsCloseShown = _useState2[1];

  var _useState3 = (0,react.useState)(),
      closeCallback = _useState3[0],
      setCloseCallback = _useState3[1];

  var _useState4 = (0,react.useState)(),
      title = _useState4[0],
      setTitle = _useState4[1];

  return {
    isOpen: isOpen,
    isCloseShown: isCloseShown,
    title: title,
    setTitle: setTitle,
    open: function open(closeCallback) {
      setCloseCallback(function () {
        return closeCallback;
      });
      setIsOpen(true);
    },
    close: function close() {
      closeCallback === null || closeCallback === void 0 ? void 0 : closeCallback();
      setIsOpen(false);
      setIsCloseShown(false);
      setCloseCallback(undefined);
    },
    showClose: function showClose() {
      setIsCloseShown(true);
    }
  };
};
var SignupDialogProvider = function SignupDialogProvider(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SignupDialogContext.Provider, {
    value: rest,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/components/curriculums/LessonChatDialog.tsx












var DynamicLessonChat = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3211), __webpack_require__.e(3631)]).then(__webpack_require__.bind(__webpack_require__, 43631)).then(function (mod) {
    return mod["default"];
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43631)];
    }
  }
});

var LessonChatDialog = function LessonChatDialog(_ref) {
  var _curriculum$sections$, _curriculum$sections$2;

  var lessonId = _ref.lessonId,
      onClose = _ref.onClose,
      user = _ref.user,
      onNext = _ref.onNext,
      handleAchieveDialog = _ref.handleAchieveDialog,
      sectionAchievePoint = _ref.sectionAchievePoint,
      sectionInbound = _ref.sectionInbound;
  var theme = (0,useTheme/* default */.Z)();
  var router = (0,next_router.useRouter)();
  var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var signupDialog = useSignupDialogContext();
  var isLessonIdPresent = lessonId !== null && lessonId !== undefined; // NOTE:
  // マイページの教科書の進み具合から開く場合は Provider を使っていないので Context は取得できないが、
  // curriculum の値は非会員向けの isFirstLesson 判定のためのものなのでログイン後は現状必要ない

  var curriculum = (0,CurriculumContext/* useCurriculumContext */.E)();
  var isFirstLesson = (curriculum === null || curriculum === void 0 ? void 0 : (_curriculum$sections$ = curriculum.sections[0]) === null || _curriculum$sections$ === void 0 ? void 0 : (_curriculum$sections$2 = _curriculum$sections$.lessons[0]) === null || _curriculum$sections$2 === void 0 ? void 0 : _curriculum$sections$2.id) === lessonId; // 会員登録未完了かつ2ページ目以降の場合は会員登録導線を表示する

  var shouldShowMemberRegistrationPrompt = (0,userRegistrationHelpers/* isMemberRegistrationIncomplete */.hY)(user) && !isFirstLesson && isLessonIdPresent;

  var handleClose = function handleClose() {
    // 会員登録導線を表示する場合は escape キーやダイアログ外をクリックしても閉じないようにする
    !shouldShowMemberRegistrationPrompt && (onClose === null || onClose === void 0 ? void 0 : onClose());
  };

  var _router$query = router.query,
      utm_source = _router$query.utm_source,
      utm_medium = _router$query.utm_medium;
  var landedViaAds = utm_source === 'google' && utm_medium === 'search' || utm_source === 'yahoo' && utm_medium === 'search';
  (0,react.useEffect)(function () {
    if (isLessonIdPresent && landedViaAds && shouldShowMemberRegistrationPrompt) {
      signupDialog === null || signupDialog === void 0 ? void 0 : signupDialog.setTitle('2ページ目以降は会員登録が必要です');
      signupDialog === null || signupDialog === void 0 ? void 0 : signupDialog.open(function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        signupDialog === null || signupDialog === void 0 ? void 0 : signupDialog.setTitle(undefined);
      });
      signupDialog === null || signupDialog === void 0 ? void 0 : signupDialog.showClose();
      return;
    }

    setIsOpen(isLessonIdPresent);
  }, [isLessonIdPresent, landedViaAds, shouldShowMemberRegistrationPrompt]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    fullScreen: fullScreen,
    fullWidth: true,
    open: isOpen,
    onClose: handleClose,
    "aria-labelledby": "responsive-dialog-title",
    PaperProps: {
      style: {
        backgroundColor: '#fff'
      }
    },
    children: [shouldShowMemberRegistrationPrompt && landedViaAds === false && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            display: 'flex',
            flexDirection: 'row'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              flex: '1',
              display: 'flex',
              flexDirection: 'column'
            },
            children: "2\u30DA\u30FC\u30B8\u76EE\u4EE5\u964D\u306F\u4F1A\u54E1\u767B\u9332\u304C\u5FC5\u8981\u3067\u3059"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              size: "small",
              onClick: onClose,
              sx: {
                ml: 1
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(graphics/* Close */.x8, {})
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
        sx: {
          mx: 0,
          px: 1
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MemberRegistrationPrompt/* default */.Z, {
          user: user
        })
      })]
    }), shouldShowMemberRegistrationPrompt === false && /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
      sx: {
        mx: 0,
        px: 1
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicLessonChat, {
        lessonId: lessonId || '',
        user: user,
        debug: router.query.debug === '1',
        onClose: onClose,
        onNext: onNext,
        handleAchieveDialog: handleAchieveDialog,
        sectionAchievePoint: sectionAchievePoint,
        sectionInbound: sectionInbound
      })
    })]
  });
};

/* harmony default export */ var curriculums_LessonChatDialog = (LessonChatDialog);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/curriculums/LessonAchieveDialog.tsx







var LessonAchieveDialog = function LessonAchieveDialog(_ref) {
  var _dialogContent$achiev, _dialogContent$achiev2, _dialogContent$achiev3, _dialogContent$achiev4, _dialogContent$achiev5;

  var open = _ref.open,
      onClose = _ref.onClose,
      onNext = _ref.onNext,
      achievePoint = _ref.achievePoint,
      nextLesson = _ref.nextLesson,
      sectionInbound = _ref.sectionInbound;

  var _useState = (0,react.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var router = (0,next_router.useRouter)();
  var dialogContent = {
    sectionElementaryThird: {
      title: 'いいペースです！',
      message: 'まずは折り返し地点を目指してどんどん読んでいきましょう！',
      image: 'elementary-third.png'
    },
    sectionElementaryHalf: {
      title: '折り返し地点を過ぎました！',
      message: '初級編も残り半分です。後半も頑張っていきましょう！',
      image: 'elementary-half.png'
    },
    sectionElementaryLast: {
      title: 'お疲れさまでした！',
      message: '初級編が読み終わりました。中級編も頑張っていきましょう！',
      messageLast: '初級編が読み終わりました。現在この教科書は全て読了済みです。',
      image: 'elementary-last.png'
    },
    sectionIntermediateThird: {
      title: 'いいペースです！',
      message: 'まずは折り返し地点を目指してどんどん読んでいきましょう！',
      image: 'intermediate-third.png'
    },
    sectionIntermediateHalf: {
      title: '折り返し地点を過ぎました！',
      message: '中級編も残り半分です。後半も頑張っていきましょう！',
      image: 'intermediate-half.png'
    },
    sectionIntermediateLast: {
      title: 'お疲れさまでした！',
      message: '中級編が読み終わりました。上級編も頑張っていきましょう！',
      messageLast: '中級編が読み終わりました！他のコンテンツも読んでみましょう！',
      messageInbound: '中級編が読み終わりました！次は各県のデータを見てみましょう。',
      image: 'intermediate-last.png'
    }
  };

  var handleInnerClick = function handleInnerClick(event) {
    event.stopPropagation();
  };

  var handleImageLoaded = function handleImageLoaded() {
    setIsLoaded(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    open: open,
    onClick: onClose,
    children: [!isLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
      sx: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-20px',
        marginLeft: '-20px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      onClick: handleInnerClick,
      sx: {
        background: '#fff',
        p: {
          xs: '32px 24px 40px',
          md: '48px 48px 56px'
        },
        textAlign: 'center',
        opacity: isLoaded ? '1' : '0',
        transition: 'opacity 0.3s ease'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
        sx: {
          fontWeight: 'bold',
          fontSize: {
            xs: '24px',
            md: '28px'
          },
          letterSpacing: '0.1em'
        },
        children: (_dialogContent$achiev = dialogContent[achievePoint]) === null || _dialogContent$achiev === void 0 ? void 0 : _dialogContent$achiev.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        sx: {
          p: 0
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          sx: {
            fontWeight: 'bold',
            fontSize: '14px',
            letterSpacing: '0.1em',
            mb: '32px'
          },
          children: nextLesson ? sectionInbound && achievePoint === 'sectionIntermediateLast' ? (_dialogContent$achiev2 = dialogContent[achievePoint]) === null || _dialogContent$achiev2 === void 0 ? void 0 : _dialogContent$achiev2.messageInbound : (_dialogContent$achiev3 = dialogContent[achievePoint]) === null || _dialogContent$achiev3 === void 0 ? void 0 : _dialogContent$achiev3.message : (_dialogContent$achiev4 = dialogContent[achievePoint]) === null || _dialogContent$achiev4 === void 0 ? void 0 : _dialogContent$achiev4.messageLast
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "dialog/".concat((_dialogContent$achiev5 = dialogContent[achievePoint]) === null || _dialogContent$achiev5 === void 0 ? void 0 : _dialogContent$achiev5.image),
          width: 488,
          height: 282,
          alt: "",
          onLoadingComplete: handleImageLoaded
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            mt: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            flexDirection: {
              xs: 'column-reverse',
              md: 'row'
            }
          },
          children: [nextLesson === null || achievePoint === 'sectionElementaryLast' || sectionInbound && (achievePoint === 'sectionElementaryLast' || achievePoint === 'sectionIntermediateLast') ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "submit",
            variant: "outlined",
            color: "secondary",
            size: "large",
            sx: {
              padding: '15px',
              width: '100%',
              maxWidth: '236px'
            },
            onClick: function onClick() {
              router.push('/curriculums/');
            },
            children: "\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8AAD\u3093\u3067\u307F\u308B"
          }) : null, nextLesson ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "submit",
            variant: "contained",
            color: "primary",
            size: "large",
            sx: {
              padding: '15px',
              fontWeight: 'bold',
              width: '100%',
              maxWidth: '236px'
            },
            onClick: onNext,
            children: "\u7D9A\u3051\u3066\u8AAD\u3080"
          }) : null]
        })]
      })]
    })]
  });
};

/* harmony default export */ var curriculums_LessonAchieveDialog = (LessonAchieveDialog);
// EXTERNAL MODULE: ./src/hooks/useLesson.tsx
var useLesson = __webpack_require__(25755);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fade/Fade.js
var Fade = __webpack_require__(9942);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(44510);
;// CONCATENATED MODULE: ./src/components/promotion/fixedBanner.tsx


var fixedBanner_templateObject, fixedBanner_templateObject2, fixedBanner_templateObject3;









var BANNER_PATH = '/seminars/';
var UTM_PARAMS = '?utm_source=seminar&utm_medium=mov&utm_campaign=float';
var STORAGE_KEY = 'banner_closed_until';

var FixedBanner = function FixedBanner(_ref) {
  var _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? true : _ref$defaultOpen;

  var _useState = (0,react.useState)(defaultOpen),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var closedUntil = localStorage.getItem(STORAGE_KEY);

    if (closedUntil && new Date(closedUntil) > new Date()) {
      setIsOpen(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var _window = window,
          scrollY = _window.scrollY,
          innerHeight = _window.innerHeight,
          document = _window.document;
      var scrollHeight = document.documentElement.scrollHeight;
      var bottomReached = scrollY + innerHeight >= scrollHeight;
      setIsVisible(scrollY > 100 && !bottomReached);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleClose = function handleClose() {
    var threeDaysLater = new Date();
    threeDaysLater.setDate(threeDaysLater.getDate() + 3);
    localStorage.setItem(STORAGE_KEY, threeDaysLater.toISOString());
    setIsOpen(false);
  };

  if (!isOpen || router.pathname === BANNER_PATH) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, {
    "in": isVisible,
    timeout: 500,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CardContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "".concat(BANNER_PATH).concat(UTM_PARAMS),
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ResponsiveImage, {
          srcPc: "/promotion/banner_pc.png",
          srcSp: "/promotion/banner_sp.png",
          alt: "\u77E5\u3063\u3066\u304A\u304D\u305F\u3044\u5E97\u8217\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0 2025\u5E74\u7248\u3010\u57FA\u672C\u306E\u30AD\u3011"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
        onClick: handleClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cancel/* default */.Z, {})
      })]
    })
  });
};

/* harmony default export */ var fixedBanner = (FixedBanner);
var CardContainer = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(fixedBanner_templateObject || (fixedBanner_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: fixed;\n  bottom: 100px;\n  right: 20px;\n  z-index: 1000;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);\n  background: #fff;\n  line-height: 0;\n  border-radius: 4px;\n\n  @media (max-width: 600px) {\n    right: 0;\n    bottom: 75px;\n    margin: 0 20px;\n  }\n\n  @media (min-width: 601px) {\n    width: 300px;\n    height: 284px;\n    bottom: 100px;\n  }\n"])));
var CloseButton = (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z)(fixedBanner_templateObject2 || (fixedBanner_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  padding: 0;\n  top: -10px;\n  right: -10px;\n  border-radius: 50%;\n  background-color: #fff;\n  &:hover {\n    background-color: #fff;\n  }\n  @media (max-width: 600px) {\n    top: -10px;\n    right: 10px;\n  }\n"])));
var ResponsiveImage = emotion_styled_browser_esm/* default.img */.Z.img(fixedBanner_templateObject3 || (fixedBanner_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: auto;\n  max-width: 100%;\n  transition: opacity 0.2s ease-in-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  @media (max-width: 600px) {\n    content: url(", ");\n  }\n\n  @media (min-width: 601px) {\n    content: url(", ");\n  }\n"])), function (props) {
  return props.srcSp;
}, function (props) {
  return props.srcPc;
});
// EXTERNAL MODULE: ./src/components/global/SignupDialog.tsx
var SignupDialog = __webpack_require__(41141);
;// CONCATENATED MODULE: ./src/components/layouts/MainLayout.tsx






var MainLayout_templateObject, MainLayout_templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var itemStyle = {
  maxWidth: '15em',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'block',
  whiteSpace: 'nowrap'
};

var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      defaultUser = _ref.user,
      _ref$noContainer = _ref.noContainer,
      noContainer = _ref$noContainer === void 0 ? false : _ref$noContainer,
      _ref$remoteUser = _ref.remoteUser,
      remoteUser = _ref$remoteUser === void 0 ? false : _ref$remoteUser,
      _ref$breadcrumbs = _ref.breadcrumbs,
      breadcrumbs = _ref$breadcrumbs === void 0 ? [] : _ref$breadcrumbs,
      sectionInbound = _ref.sectionInbound,
      sectionAchievePoint = _ref.sectionAchievePoint;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(defaultUser),
      user = _useState[0],
      setUser = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoadingUser = _useState2[0],
      setIsLoadingUser = _useState2[1];

  var _useLesson = (0,useLesson/* default */.Z)({
    previewAccessToken: router.query.previewAccessToken
  }),
      currentLessonId = _useLesson.currentLessonId,
      pushLesson = _useLesson.push;

  var _useState3 = (0,react.useState)(false),
      openAchieveDialog = _useState3[0],
      setOpenAchieveDialog = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      achieveDialogPoint = _useState4[0],
      setAchieveDialogPoint = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      nextLesson = _useState5[0],
      setNextLesson = _useState5[1];

  var signupDialog = useSignDialogContextState();

  var handleAchieveDialog = function handleAchieveDialog(handle, nextLesson, achievePoint) {
    if (handle) {
      setAchieveDialogPoint(achievePoint !== null && achievePoint !== void 0 ? achievePoint : '');
      setOpenAchieveDialog(true);
      setNextLesson(nextLesson !== null && nextLesson !== void 0 ? nextLesson : '');
    } else {
      setOpenAchieveDialog(false);
      pushLesson(nextLesson);
    }
  };

  (0,react.useEffect)(function () {
    if (!remoteUser) {
      setIsLoadingUser(false);
      return;
    }

    var fetchUser = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var user;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoadingUser(true);
                _context.next = 3;
                return (0,api/* getCurrentUser */.ts)();

              case 3:
                user = _context.sent;
                setUser(user);
                setIsLoadingUser(false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchUser() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchUser();
  }, [remoteUser]);
  var canShowBannerPage = !!router.pathname.match(/^\/?$/) || !!router.pathname.match(/^\/about\/?$/) || !!router.pathname.match(/^\/downloadThanks\/?$/) || !!router.pathname.match(/^\/account\/?.*$/) || !!router.pathname.match(/^\/cases\/?.*$/) || !!router.pathname.match(/^\/curriculums\/?.*$/) || !!router.pathname.match(/^\/news\/?.*$/) || !!router.pathname.match(/^\/lectures\/?.*$/) || !!router.pathname.match(/^\/whitepapers\/?.*$/);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "main-layout",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(global_Header, {
      user: user !== null && user !== void 0 ? user : null,
      isLoadingUser: isLoadingUser,
      id: "main-header"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrapper, {
      children: [breadcrumbs.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
            separator: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: itemStyle,
              children: "\u203A"
            }),
            "aria-label": "breadcrumb",
            children: [[pageTitles/* top */.we, '/']].concat((0,toConsumableArray/* default */.Z)(breadcrumbs)).map(function (_ref3, i) {
              var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
                  label = _ref4[0],
                  href = _ref4[1];

              return href ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                  underline: "hover",
                  color: "inherit",
                  sx: itemStyle,
                  children: label
                })
              }, i) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                style: itemStyle,
                children: label
              }, i);
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignupDialogProvider, _objectSpread(_objectSpread({}, signupDialog), {}, {
        children: [noContainer ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          sx: {
            position: 'relative',
            zIndex: 1
          },
          children: children
        }), !isLoadingUser && !user && router.pathname !== '/thanks' && /*#__PURE__*/(0,jsx_runtime.jsx)(global_BottomEyecatch, {
          isLoggedIn: !!user
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(global_Footer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollTop/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(curriculums_LessonChatDialog, {
          lessonId: currentLessonId,
          user: user !== null && user !== void 0 ? user : null,
          onClose: function onClose() {
            return pushLesson(null);
          },
          onNext: pushLesson,
          handleAchieveDialog: handleAchieveDialog,
          sectionAchievePoint: sectionAchievePoint,
          sectionInbound: sectionInbound
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(curriculums_LessonAchieveDialog, {
          open: openAchieveDialog,
          onClose: function onClose() {
            return handleAchieveDialog(false, null, null);
          },
          onNext: function onNext() {
            return handleAchieveDialog(false, nextLesson, null);
          },
          achievePoint: achieveDialogPoint,
          sectionInbound: sectionInbound,
          nextLesson: nextLesson
        }), canShowBannerPage && /*#__PURE__*/(0,jsx_runtime.jsx)(fixedBanner, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SignupDialog/* default */.Z, {
          open: signupDialog.isOpen,
          onClose: signupDialog.close,
          user: user !== null && user !== void 0 ? user : null,
          showClose: signupDialog.isCloseShown,
          title: signupDialog.title
        })]
      }))]
    })]
  });
};

/* harmony default export */ var layouts_MainLayout = (MainLayout);
var BreadcrumbsWrapper = emotion_styled_browser_esm/* default.div */.Z.div(MainLayout_templateObject || (MainLayout_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #f7f7f7;\n  display: flex;\n  padding: 10px 0;\n  position: relative;\n  z-index: 2;\n"])));
var ContentWrapper = emotion_styled_browser_esm/* default.div */.Z.div(MainLayout_templateObject2 || (MainLayout_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 131px;\n\n  @media (max-width: 1069px) {\n    margin-top: 149px;\n  }\n\n  @media (max-width: 899px) {\n    margin-top: 110px;\n  }\n\n  @media (max-width: 599px) {\n    margin-top: 101px;\n  }\n"])));

/***/ }),

/***/ 78866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ prefix; },
/* harmony export */   "t": function() { return /* binding */ s3AssetURL; }
/* harmony export */ });
var prefix = "".concat(("https://kutikomi-academy-production.imgix.net" || 0).replace(/\/$/, ''), "/");
var s3AssetURL = function s3AssetURL(path) {
  var prefix = ("https://kutikomi-academy-resources-production.s3-ap-northeast-1.amazonaws.com" || 0).replace(/\/$/, '');
  return "".concat(prefix, "/").concat(path.replace(/^\//, ''));
};

/***/ }),

/***/ 45082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ footerLinks; },
/* harmony export */   "s": function() { return /* binding */ sitePages; }
/* harmony export */ });
/* harmony import */ var _pageTitles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88499);

var sitePages = [[_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .news */ .r, '/news/', '/header/icon_data.svg'], [_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .curriculums */ .vj, '/curriculums/', '/header/icon_book.svg'], [_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .whitepapers */ .jK, '/whitepapers/', '/header/icon_marketing.svg'], [_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .lectures */ .En, '/lectures/', '/header/icon_movie.svg'], [_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .seminars */ .Qd, '/seminars/', '/header/icon_seminar.svg'], [_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .cases */ .c6, '/cases/', '/header/icon_casestudy.svg'], // ['先輩に聞く', ''],
[_pageTitles__WEBPACK_IMPORTED_MODULE_0__/* .about */ .jZ, '/about/', '/header/icon_about.svg']];
var footerLinks = [['運営会社', 'https://mov.am/company/'], ['プライバシーポリシー', 'https://kutikomi.com/privacy_policy/'], ['ご利用規約', '/terms/'], ['お問い合わせ', '/contact/']];

/***/ }),

/***/ 88499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": function() { return /* binding */ myPage; },
/* harmony export */   "En": function() { return /* binding */ lectures; },
/* harmony export */   "PX": function() { return /* binding */ contact; },
/* harmony export */   "Qd": function() { return /* binding */ seminars; },
/* harmony export */   "c6": function() { return /* binding */ cases; },
/* harmony export */   "gZ": function() { return /* binding */ pageTitles; },
/* harmony export */   "jK": function() { return /* binding */ whitepapers; },
/* harmony export */   "jZ": function() { return /* binding */ about; },
/* harmony export */   "r": function() { return /* binding */ news; },
/* harmony export */   "vj": function() { return /* binding */ curriculums; },
/* harmony export */   "we": function() { return /* binding */ top; }
/* harmony export */ });
var pageTitles = {
  top: 'トップページ',
  myPage: 'マイページ',
  lectures: '動画で学ぶ',
  seminars: 'セミナーで学ぶ',
  whitepapers: '店舗マーケティング資料を見る',
  cases: '活用事例で学ぶ',
  curriculums: '教科書で学ぶ',
  news: '記事を読む',
  about: '口コミアカデミーとは',
  contact: 'お問い合わせ'
};
/**
 * @deprecated
 */

var top = 'トップページ';
/**
 * @deprecated
 */

var myPage = 'マイページ';
/**
 * @deprecated
 */

var lectures = '動画で学ぶ';
/**
 * @deprecated
 */

var seminars = 'セミナーで学ぶ';
/**
 * @deprecated
 */

var whitepapers = '店舗マーケティング資料を見る';
/**
 * @deprecated
 */

var cases = '活用事例で学ぶ';
/**
 * @deprecated
 */

var curriculums = '教科書で学ぶ';
/**
 * @deprecated
 */

var news = '記事を読む';
/**
 * @deprecated
 */

var about = '口コミアカデミーとは';
/**
 * @deprecated
 */

var contact = 'お問い合わせ';

/***/ }),

/***/ 56532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useCurriculumContext; },
/* harmony export */   "T": function() { return /* binding */ CurriculumProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var CurriculumContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
var useCurriculumContext = function useCurriculumContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CurriculumContext);
};
var CurriculumProvider = function CurriculumProvider(_ref) {
  var curriculum = _ref.curriculum,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CurriculumContext.Provider, {
    value: curriculum,
    children: children
  });
};

/***/ }),

/***/ 16736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useScrollTopButtonPositionContext; },
/* harmony export */   "e": function() { return /* binding */ ScrollTopButtonPositionProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var ScrollTopButtonPositionContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  right: 0,
  bottom: 0
});
var useScrollTopButtonPositionContext = function useScrollTopButtonPositionContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScrollTopButtonPositionContext);
};
var ScrollTopButtonPositionProvider = function ScrollTopButtonPositionProvider(_ref) {
  var children = _ref.children,
      scrollTopButtonPosition = _ref.scrollTopButtonPosition;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollTopButtonPositionContext.Provider, {
    value: scrollTopButtonPosition,
    children: children
  });
};

/***/ }),

/***/ 92736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isValidPhoneNumber; }
/* harmony export */ });
/* unused harmony export isValidURL */
var phoneNumberRegex = /^0\d{9,10}$/; // 0から始まり、残りの数字9桁または10桁の半角数字

var phoneNumberRegex2 = /^0(\d)\1{8,9}$/; // 01111111111などのゾロ目

var phoneNumberRegex3 = /^(\d)\1{10,11}$/; // 11111111111などのゾロ目

var urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
var isValidPhoneNumber = function isValidPhoneNumber(phoneNumber) {
  if (phoneNumber.indexOf('--') !== -1) {
    return false;
  }

  var replaceValue = phoneNumber.replace(/-/g, '');
  return phoneNumberRegex.test(replaceValue) && !phoneNumberRegex2.test(replaceValue) && !phoneNumberRegex3.test(replaceValue);
};
var isValidURL = function isValidURL(url) {
  return urlRegex.test(url);
};

/***/ }),

/***/ 83972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mk": function() { return /* binding */ generateDialogTitle; },
/* harmony export */   "hY": function() { return /* binding */ isMemberRegistrationIncomplete; },
/* harmony export */   "lI": function() { return /* binding */ isOnlyStep1Completed; }
/* harmony export */ });
/* harmony import */ var src_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76738);

var generateDialogTitle = function generateDialogTitle(user) {
  var REGISTRATION_REQUIRED_MESSAGE = '会員登録が必要です';
  var ADDITIONAL_ANSWERS_REQUIRED_MESSAGE = '追加で回答をいただく必要があります';

  if (!user) {
    return REGISTRATION_REQUIRED_MESSAGE;
  }

  if (isOnlyStep1Completed(user)) {
    return ADDITIONAL_ANSWERS_REQUIRED_MESSAGE;
  }

  if (!user.filledAll) {
    return REGISTRATION_REQUIRED_MESSAGE;
  }

  return '';
};
var isOnlyStep1Completed = function isOnlyStep1Completed(user) {
  return (user === null || user === void 0 ? void 0 : user.completedRegistrationSteps[0]) === src_types__WEBPACK_IMPORTED_MODULE_0__/* .RegistrationStep.Basic */ .Nm.Basic && (user === null || user === void 0 ? void 0 : user.completedRegistrationSteps.length) === 1;
};
var isMemberRegistrationIncomplete = function isMemberRegistrationIncomplete(user) {
  return !user || (user === null || user === void 0 ? void 0 : user.filledAll) === false;
};

/***/ }),

/***/ 25755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17674);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var useLesson = function useLesson() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$lessonId = _ref.lessonId,
      lessonId = _ref$lessonId === void 0 ? '' : _ref$lessonId,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      previewAccessToken = _ref.previewAccessToken;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      selectedLessonId = _useState[0],
      setSelectedLessonId = _useState[1];

  var _ref2 = router.query,
      currentLessonId = _ref2.lessonId; // const link = `${router.asPath.replace(/\?.*/, '')}?lessonId=${lessonId}`;

  var link = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var params = getSearchParams(router.query);
    lessonId !== null && lessonId !== undefined && params.set('lessonId', lessonId);
    var queryString = params.toString();

    if (previewAccessToken) {
      params.set('previewAccessToken', previewAccessToken);
    }

    return "".concat(router.asPath.replace(/\?.*/, '')).concat(queryString.length > 0 ? "?".concat(queryString) : '');
  }, [router, lessonId]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ((!currentLessonId || currentLessonId !== lessonId) && selectedLessonId === lessonId) {
      onClose();
    }

    setSelectedLessonId(currentLessonId);
  }, [currentLessonId, lessonId, onClose, selectedLessonId]);

  var push = function push(lessonId) {
    var params = getSearchParams(router.query);
    params["delete"]('lessonId');
    lessonId !== null && params.set('lessonId', lessonId);
    var queryString = params.toString();
    var newPath = "".concat(router.asPath.replace(/\?.*/, '')).concat(queryString.length > 0 ? "?".concat(queryString) : '');

    if (previewAccessToken) {
      params.set('previewAccessToken', previewAccessToken);
    }

    if (router.asPath !== newPath) {
      // NOTE: コード的には shallow: true にしても動きそうだが、chrome のみ発生する不具合があったため様子 shallow: false にしている
      // https://www.notion.so/movinc/856aaf508f6f4c3cafc0e22568466a12?pvs=4
      router.push(newPath, undefined);
    }
  };

  return {
    link: link,
    currentLessonId: currentLessonId,
    push: push
  };
};

function getSearchParams(query) {
  var params = new URLSearchParams();
  Object.entries(query).forEach(function (_ref3) {
    var _ref4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    val && params.append(key, val.toString());
  });
  return params;
}

/* harmony default export */ __webpack_exports__["Z"] = (useLesson);

/***/ }),

/***/ 76738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IM": function() { return /* binding */ InquiryType; },
  "Nm": function() { return /* reexport */ RegistrationStep; },
  "yb": function() { return /* reexport */ allRegistrationSteps; }
});

// UNUSED EXPORTS: ActivityType

;// CONCATENATED MODULE: ./src/types/RegistrationStep.ts
var RegistrationStep;

(function (RegistrationStep) {
  RegistrationStep[RegistrationStep["Basic"] = 0] = "Basic";
  RegistrationStep[RegistrationStep["WebMediaAdoptions"] = 1] = "WebMediaAdoptions";
  RegistrationStep[RegistrationStep["WebMediaInterests"] = 2] = "WebMediaInterests";
  RegistrationStep[RegistrationStep["EmailPasswordSignup"] = 3] = "EmailPasswordSignup";
})(RegistrationStep || (RegistrationStep = {}));

var allRegistrationSteps = [RegistrationStep.Basic, RegistrationStep.WebMediaAdoptions, RegistrationStep.WebMediaInterests];
;// CONCATENATED MODULE: ./src/types/index.ts
var ActivityType;

(function (ActivityType) {
  ActivityType["LessonStart"] = "lesson.start";
  ActivityType["LessonEnd"] = "lesson.end";
  ActivityType["WhitepaperDownload"] = "whitepaper.download";
  ActivityType["SeminarRequest"] = "seminar.request";
  ActivityType["SeminarAttend"] = "seminar.attend";
  ActivityType["SeminarView"] = "seminar.view";
  ActivityType["LectureRequest"] = "lecture.request";
  ActivityType["LectureAttend"] = "lecture.attend";
  ActivityType["LectureView"] = "lecture.view";
  ActivityType["CaseDownload"] = "case.download";
})(ActivityType || (ActivityType = {}));

var InquiryType = {
  Large: 'large',
  FoodRetail: 'food_retail',
  Other: 'other',
  New: 'new'
};


/***/ })

}]);